import { render, staticRenderFns } from "./ElementPagination.vue?vue&type=template&id=f4d5ca20&scoped=true"
import script from "./ElementPagination.vue?vue&type=script&lang=js"
export * from "./ElementPagination.vue?vue&type=script&lang=js"
import style0 from "./ElementPagination.vue?vue&type=style&index=0&id=f4d5ca20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d5ca20",
  null
  
)

export default component.exports